/* eslint-disable react/prop-types */
import React, { useEffect, useRef, useState } from 'react';
import { useTheme } from 'styled-components';
import { tokens, inkA } from '../tokens';

// 48px inset search field. The input updates instantly as you type, but
// `onChange` is debounced by `debounce` ms (0 = fire immediately) so consumers
// don't fire an API request on every keystroke.
const SearchInput = ({
  defaultValue = '',
  onChange,
  placeholder,
  debounce = 0,
}) => {
  const theme = useTheme();
  const t = tokens(theme);
  const [text, setText] = useState(defaultValue);
  const timer = useRef(null);

  useEffect(() => () => clearTimeout(timer.current), []);

  const handleChange = (e) => {
    const next = e.target.value;
    setText(next);
    if (typeof onChange !== 'function') return;
    if (debounce > 0) {
      clearTimeout(timer.current);
      timer.current = setTimeout(() => onChange(next), debounce);
    } else {
      onChange(next);
    }
  };

  return (
    <input
      type="text"
      value={text}
      placeholder={placeholder}
      onChange={handleChange}
      style={{
        flex: 1,
        height: 48,
        border: '1px solid ' + inkA(theme, 0.1),
        background: t.inset,
        color: t.text,
        fontSize: '14.5px',
        fontWeight: 500,
        borderRadius: 8,
        padding: '0 18px',
        width: '100%',
        boxSizing: 'border-box',
        outline: 'none',
      }}
    />
  );
};

export default SearchInput;
